<template>
  <v-dialog
    max-width="900px"
    scrollable
    :value="item !== null"
    :transition="false"
    :persistent="false"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card
      min-height="620px"
      class="overflow-y-hidden"
      :loading="isLoading"
    >
      <v-card-title class="headline">Отправленные данные аккаунта
        <span>&nbsp;</span>
        <router-link
          v-if="item.actionAuthor.id && item.actionAuthor.id !== 'N/A'"
          :to="{ name: 'page-account', params: { id: item.actionAuthor.id } }"
          title="Открыть"
        >
          {{ convertToPhone(item.actionAuthor.login) }}
        </router-link>
        <p v-else-if="item.actionAuthor.login !== 'N/A'">
          {{ convertToPhone(item.actionAuthor.login) }}
        </p>
        <span>&nbsp;</span>
        "{{ item.actionAuthor.ip }}"
      </v-card-title>
      <v-card-text v-if="item.payload?.data">
        <div style="margin: 10px">
          <VueJsonPretty
            :data="item.payload.data"
            :deep="1"
            showLineNumber
            showIcon
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-btn
            justify="space-around"
            @click="$emit('close')"
          >
            Закрыть
          </v-btn>
          <v-spacer/>
          <v-btn
            v-if="link"
            :to="link"
            color="primary darken-2"
            @click="$emit('close')"
          >
             Перейти к сущности
          </v-btn>
          </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { convertToPhone } from '@/configs/numbers'
import { getLink, getLinkQuery } from '@/utils/getActionsDictionary'
export default {
  name: 'ActionItemDialog',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      link: {},
      isLoadingDialog: this.isLoading
    }
  },
  async mounted () {
    this.isLoadingDialog = true
    if (this.item?.operationName.match(/delete/i)) { return false }
    this.link = getLink(this.item)
    if (!this.link) {
      this.link = await getLinkQuery(this, this.item)
    }
    this.isLoadingDialog = false
  },
  methods: {
    convertToPhone
  }
}
</script>
<style>
.v-application.theme--light .vjs-tree__node:hover {
  background-color: rgba(234, 234, 234, 0.85);
}
.v-application.theme--dark .vjs-tree__node:hover{
  background-color: #4f4f4f;
}
</style>
